import axios from 'axios'
const anabilimanasanat = async () => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + '/api/v1/anabilim',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const anabilimanasanatCreate = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/anabilim/create',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const anabilimanasanatUpdate = async (id,data) => {
    let response;
    var config = {
        method: 'put',
        url: process.env.REACT_APP_API_URL + '/api/v1/anabilim/'+id,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};


export {
    anabilimanasanat,
    anabilimanasanatCreate,
    anabilimanasanatUpdate
};